import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { mapAuthErrorMessage, useAuth } from "../auth/AuthProvider";

function LoginPage() {
    const { isAuthenticated, isBooting, login, authMessage, setAuthMessage } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    const redirectTo = location.state?.from || "/";

    if (!isBooting && isAuthenticated) {
        return <Navigate to={redirectTo} replace />;
    }

    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        setError("");
        setAuthMessage("");

        try {
            await login(email, password);
            setPassword("");
            navigate(redirectTo, { replace: true });
        } catch (err) {
            setError(mapAuthErrorMessage(err));
        } finally {
            setLoading(false);
        }
    }

    return (
        <section className="container py-5">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-10 col-md-8 col-lg-5">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-4">
                            <h1 className="h4 mb-2">Connexion</h1>
                            <p className="text-secondary mb-4">Accès au backoffice technicien.</p>

                            {authMessage && <div className="alert alert-warning py-2">{authMessage}</div>}
                            {error && <div className="alert alert-danger py-2">{error}</div>}

                            <form onSubmit={handleSubmit} className="d-grid gap-3">
                                <div>
                                    <label className="form-label" htmlFor="email">Email</label>
                                    <input
                                        id="email"
                                        type="email"
                                        className="form-control"
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                        autoComplete="email"
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="form-label" htmlFor="password">Mot de passe</label>
                                    <input
                                        id="password"
                                        type="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(event) => setPassword(event.target.value)}
                                        autoComplete="current-password"
                                        required
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary" disabled={loading || isBooting}>
                                    {loading ? "Connexion..." : "Se connecter"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LoginPage;
